import 'styles/components/spinner.css';

const LoadSpinner = ({ className, ...props }) => {
  return <span className={`loader ${className ?? ''}`} {...props} />;
};

export default LoadSpinner;
